import type { Step } from "../script";

export const retentionForecast: Step[] = [
  {
    kind: "msg",
    id: "msg-06a",
    tokens:
      "week recap: 18 interventions fired, 16 accepted. £12,400 of tc40 suppressed. €2.84m of merchant volume kept on your rails.",
    pauseAfter: 1200,
  },
  {
    kind: "panel",
    view: "intelligence",
    focus: { kind: "retention" },
    pauseAfter: 1400,
  },
  {
    kind: "msg",
    id: "msg-06b",
    tokens:
      "ytd that's €14.2m. every line in the ledger signed + attributable to your acquirer key.",
    pauseAfter: 1200,
  },
];
